import type { ReactElement } from 'react';
import MuiTooltip from '@mui/material/Tooltip';

/** Angular Material `matTooltipPosition`. */
export type TooltipPosition = 'above' | 'below' | 'left' | 'right' | 'before' | 'after';

const PLACEMENTS = {
  above: 'top',
  below: 'bottom',
  left: 'left',
  right: 'right',
  // 'before'/'after' follow the text direction; the app is left-to-right
  before: 'left',
  after: 'right',
} as const;

/**
 * `matTooltip` (+ `matTooltipPosition`, default 'below' like mat-tooltip). Shows after a short hover delay like
 * Material; renders nothing extra when there is no text.
 */
export function Tooltip({
  title,
  placement = 'below',
  children,
}: {
  title?: string | null;
  placement?: TooltipPosition;
  children: ReactElement;
}) {
  if (!title) return children;
  return (
    <MuiTooltip
      title={title}
      placement={PLACEMENTS[placement]}
      arrow={false}
      enterDelay={0}
      slotProps={{ tooltip: { className: 'mat-mdc-tooltip' }, popper: { className: 'mat-mdc-tooltip-panel' } }}
    >
      {children}
    </MuiTooltip>
  );
}
